import SidebarDialogues from './SidebarDialogues'

export default SidebarDialogues
